<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { componentStore } from "@common/componentStore/componentStore";

const editorSettings = {};

const actionParamWizardConfig = {
    cId: "actionParamWizard",
    cType: "actionParamWizard",
    cTitle: "Action Param Wizard",
    cTemplate: `<div v-if="steps && steps.length">
        <div v-for="(step, index) in steps" :key="index">
            <div v-show="currentStep === index || showAllSteps">
                <div v-if="step.type !== 'records'">
                    <control :name="step.controlName" :prop-config="paramControls[step.controlName]" :value="output[step.key]" @update:value="output[step.key] = $event"></control>
                </div>
                <div v-else>
                    <p>Select record(s) {{records.length}}</p>
                    <div style="height: 300px; overflow-y: auto;">
                        <div v-for="(record, index) in records" :key="index">
                            <a @click="selectRecord(record)" style="padding: 5px; font-weight: bold; background: #eee; margin-bottom: 2px; cursor:pointer; display: block;">{{ record.label }}{{ record.selected ? ' (selected)' : '' }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="text-align: right; padding: 1rem 0;">
            <button type="button" @click="closeDialog()" style="padding: 10px; display: block; float: left; font-weight: bold; background: #eee; margin-right: 10px;">Cancel</button>
            <button type="button" @click="setCurrentStep('back')" v-if="!showAllSteps && currentStep !== 0" style="padding: 10px; display: inline-block; font-weight: bold; background: #eee; margin-right: 10px;">Previous Step</button>
            <button type="button" :disabled="checkDisabled()" @click="setCurrentStep('forward')" style="padding: 10px; display: inline-block; font-weight: bold; background: #eee;">
                {{ primaryButtonLabel }}</button>
        </div>
    </div>`
};

const actionParamWizardCmp = {
    name: 'actionParamWizard',
    editorSettings: editorSettings,
    props: {
        paramValues: {
            type: Object
        },
        paramControls: {
            type: Array
        },
        requiredParams: {
            type: Array
        },
        steps: {
            type: Array
        },
        showAllSteps: {
            type: Boolean,
            default: false
        },
        submitButtonLabel: {
            type: String,
            default: false
        },
        action: {
            type: String,
            default: false
        }
    },
    data() {
        return {
            currentStep: -1,
            records: [],
            output: {},
            selectedOpp: false,
        };
    },
    computed: {
        primaryButtonLabel() {
            return this.currentStep === (this.steps.length - 1) || this.showAllSteps
                ? this.submitButtonLabel || 'Submit'
                : 'Next Step';
        }
    },
    methods: {
        closeDialog(isSuccess) {
            let dialogId = this.contextDialogId || 'actionParamsDialog';
            library.hideDialog(dialogId, isSuccess);
        },
        setOutputObj() {
            this.$emit('update:propParamValues', false); // Added this to temporarily fix object reactivity
            this.$emit('update:propParamValues', this.output);
        },
        async setCurrentStep(direction) {
            let index = this.currentStep;
            if (!this.steps) return false;
            if (index === this.steps.length - 1 || this.showAllSteps) {
                this.$emit('update:wizardComplete', true);
                return this.closeDialog(true);
            }
            let newIndex = direction === 'forward' ? index + 1 : index - 1;
            let newStep = this.steps[newIndex];
            // Clear out field values from current step & set the currentStep to the newIndex
            if (direction !== 'forward') {
                // TODO clear control values
                // console.log(step);
            }
            this.currentStep = newIndex;
            // Initialize the records for nextStep
            let addParams = false;
            let parentRecordObj = false;
            let parentRecord = newStep
                && newStep.parentRecords
                && this.output[newStep.parentRecords.key];
            if (parentRecord) {
                parentRecordObj = {};
                let pspKey = {
                    'vol': '1',
                    'opp': '2',
                    'org': '3',
                };
                if (!Array.isArray(parentRecord)) parentRecord = [parentRecord];
                parentRecordObj[pspKey[newStep.parentRecords.psp]] = parentRecord;
            }
            if (newStep.type === 'records') {
                if (newStep.defaults && newStep.defaults.psp === 'sch') {
                    addParams = {
                        dateSpecific: 1,
                        dateRange: 'today_through_plus',
                        datePeriodValue: 365,
                        gridMode: 1
                    };
                }
                if (!newStep.defaults) newStep.defaults = { psp: 'vol' };
                if (
                    newStep.defaults.psp !== 'sch'
                    || (newStep.defaults.psp === 'sch' && (this.action === 'deleteShift' || (this.selectedOpp && this.selectedOpp.OPP_HAS_SS === 'Yes')))
                ) {
                    this.getRecords(false, false, newStep.defaults && newStep.defaults.psp, parentRecordObj, addParams);
                }
                else {
                    // Skip Sch records step if the opp does not have shifts
                    this.setCurrentStep('forward');
                }
            }
            return this.currentStep;
        },
        selectRecord(record) {
            let step = this.steps[this.currentStep];
            let recordKey = step && step.key;
            if (!recordKey) return;
            if (!this.output[recordKey]) this.output[recordKey] = [];
            if (step.allowMultiple) {
                let existingIndex = this.output[recordKey].indexOf(record.rowID);
                if (existingIndex > -1) this.output[recordKey].splice(existingIndex, 1);
                else this.output[recordKey].push(record.rowID);
            } else {
                this.records.forEach((iRecord) => {
                    iRecord.selected = false;
                });
                this.output[recordKey] = record.rowID;
            }
            record.selected = !record.selected;
            let newOutput = library.cloneObj(this.output);
            this.output = false;
            this.output = newOutput;
            if (step.defaults && step.defaults.psp && step.defaults.psp === 'opp') {
                this.selectedOpp = record;
            }
            this.setOutputObj();
        },
        async getRecords(event, elem, psp, parentRecords, addParams) {
            // set default perspective & parent records
            if (!psp) psp = this.output.psp;
            if (!psp) psp = this.output.recordPsp;
            if (!parentRecords) parentRecords = false;
            if (!addParams) addParams = false;
            // reset records
            this.records = [];
            // get new records
            let records = [];
            let fields = {
                vol: [
                    'VOL_FIRST_NAME',
                    'VOL_LAST_NAME',
                    'VOL_DOB'
                ],
                opp: [
                    'OPP_TITLE',
                    'OPP_HAS_ANY_SS_IN_FUTURE',
                    'OPP_HAS_SS',
                    'OPP_HAS_ANY_SS'
                ],
                org: [
                    'ORG_TITLE'
                ],
                mem: [
                    'MEM_FIRST_NAME',
                    'MEM_LAST_NAME',
                    'MEM_DOB'
                ],
                ae: [
                    'AE_TITLE'
                ],
                sch: [
                    'SS_START_TIME',
                    'SS_END_TIME',
                    'SS_END_DATE',
                    'SS_DATE',
                    'SS_DESC',
                ]
            };
            let request = await this.sDs.post('ec_getGrid', psp, false, fields[psp], false, false, parentRecords, addParams);
            // this.records = records;
            let setLabel = (iRecord) => {
                if (iRecord.label) return;
                let label = "";
                if (iRecord.SS_START_TIME) {
                    label = iRecord.SS_START_TIME + ' ' + iRecord.SS_DATE + ' (' + iRecord.SS_DESC + ')';
                }
                else if (iRecord.OPP_TITLE) label = iRecord.OPP_TITLE;
                else if (iRecord.ORG_TITLE) label = iRecord.ORG_TITLE;
                else if (iRecord.AE_TITLE) label = iRecord.AE_TITLE;
                else if (iRecord.VOL_FIRST_NAME) {
                    label = iRecord.VOL_FIRST_NAME;
                    label += iRecord.VOL_LAST_NAME ? " " + iRecord.VOL_LAST_NAME : "";
                }
                else if (iRecord.MEM_FIRST_NAME) {
                    label = iRecord.MEM_FIRST_NAME;
                    label += iRecord.MEM_LAST_NAME ? " " + iRecord.MEM_LAST_NAME : "";
                }
                else if (iRecord.rowID) label = iRecord.rowID;
                else label = 'Record';
                iRecord.label = label;
            };
            if (request.data && typeof request.data === 'object') {
                records = Object.keys(request.data).map((key) => {
                    request.data[key].selected = false;
                    if (!request.data[key].label) setLabel(request.data[key]);
                    return request.data[key];
                });
            }
            this.records = records;
            // this.setOutputObj();
        },
        checkDisabled() {
            return Object.values(this.controls).some((ctrl) => Array.isArray(ctrl.validationErrors) && ctrl.validationErrors.length > 0);
        }
    },
    mounted() {
        let mountInterval = setInterval(() => {
            if (this.steps && this.steps.length) {
                this.output = this.paramValues;
                if (!this.showAllSteps) this.setCurrentStep('forward');
                clearInterval(mountInterval);
            }
        }, 100); // NOSONAR
    },
    components: {
        control: defineAsyncComponent(() => import('./control/control.vue'))
    }
};
componentStore.initComponent(actionParamWizardCmp, actionParamWizardConfig);
export { actionParamWizardConfig, actionParamWizardCmp };
export default actionParamWizardCmp;
</script>
